import { Api } from './Api';

export class BalanceApi {
  static async getBalance() {
    return await Api.get('/wallet/api/v1/balance');
  }

  static async createBalance() {
    return await Api.post('/wallet/api/v1/balance');
  }
}
